import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const AUTH_PATHS = ["/home", "/photos", "/account"];

function NavMenu() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleOutsideClick(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [open]);

  if (!AUTH_PATHS.includes(location.pathname)) return null;

  return (
    <nav
      ref={menuRef}
      style={{
        position: "fixed", top: 0, left: 0, right: 0, height: 48,
        background: "#1976d2", display: "flex", alignItems: "center",
        padding: "0 16px", zIndex: 2000, boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
      }}
    >
      <button
        onClick={() => setOpen(o => !o)}
        aria-label={open ? "Close menu" : "Open menu"}
        style={{
          background: "none", border: "none", color: "#fff",
          fontSize: 22, cursor: "pointer", padding: "0 8px",
          lineHeight: 1, display: "flex", alignItems: "center"
        }}
      >
        {open ? "✕" : "☰"}
      </button>
      <span style={{ color: "#fff", fontWeight: 600, marginLeft: 8, fontSize: 16 }}>
        nopass
      </span>
      {open && (
        <div style={{
          position: "absolute", top: 48, left: 0,
          background: "#fff", boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
          borderRadius: "0 0 8px 0", minWidth: 220, zIndex: 2001
        }}>
          {[
            { to: "/home", label: "Home" },
            { to: "/photos", label: "Photos" },
            { to: "/account", label: "Account Management" },
          ].map(({ to, label }, i, arr) => (
            <Link
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              style={{
                display: "block", padding: "14px 24px", color: "#1976d2",
                textDecoration: "none", fontSize: 15, fontWeight: 500,
                borderBottom: i < arr.length - 1 ? "1px solid #f0f0f0" : "none",
                background: location.pathname === to ? "#e3f0fb" : "transparent"
              }}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}

export default NavMenu;
